module.exports = __webpack_public_path__ + "img/banner_03.ab5dd6e3.jpg";